import React, { useCallback } from "react";
import { styled, Typography, TypographyProps } from "@material-ui/core";
import { Link, LinkProps, useHistory } from "react-router-dom";
import { trimUrlSlashes } from "../../utils/trimUrlSlashes";

const BaseLink = styled(Link)({
  display: "inline-block",
  textDecoration: "none",
  whiteSpace: "nowrap",
});

// Customisation of Link Component
// No underline, avoids strikethrough on parent elements
// Removes duplication of "/"s in the linked path
export const CustomLink: React.FC<
  LinkProps<any> & { typographyProps?: Partial<TypographyProps> }
> = ({ children, to, typographyProps, ...props }) => {
  return (
    /* istanbul ignore next */
    <BaseLink to={typeof to !== "string" ? to : trimUrlSlashes(to)} {...props}>
      <Typography variant="body2" color="primary" {...typographyProps}>
        {children}
      </Typography>
    </BaseLink>
  );
};

// A link like button, e.g., View older agreements
export const ButtonLink: React.FC<{
  handleClick: () => void;
  text: string;
  href?: string;
}> = ({ handleClick, text, href, ...props }) => {
  const onClick = useCallback(
    (e: any) => {
      e.preventDefault();
      handleClick();
    },
    [handleClick],
  );
  return (
    <BaseLink to={href || "#"} onClick={onClick} {...props}>
      <Typography variant="body1" color="primary" component="span">
        {text}
      </Typography>
    </BaseLink>
  );
};

// Links to a page, e.g, View Bills,
export const PageLink: React.FC<{
  path: string;
  text: string;
  state?: any;
}> = ({ path, text, state, ...props }) => {
  const history = useHistory();
  const handleClick = useCallback(() => {
    history.push(path, {
      ...state,
    });
  }, [history, path, state]);
  return (
    <ButtonLink handleClick={handleClick} text={text} href={path} {...props} />
  );
};
